<template>
  <div class="about-container">
    <h1>About me</h1>
    <div class="about">
      <div class="img">
        <img src="@/assets/profile-pic.webp">
      </div>
      <div class="name">Dominika Szymanska</div>
      <div class="dimmed">@nidomika</div>
      <div class="text">
        <p>
          A 2nd year Computer Science student starting their journey with QA.<br/>
          Has basic knowledge of JavaScript, Python, C++, HTML and CSS. <br/>
          Strives to learn something new but is still unsure what should it be.
        </p>
        <br/>
        <br/>
        <p class="dimmed">
          Background photo by <a href="https://unsplash.com/@lemodernaffliction" class="underline dimmed">modern affliction</a> on <a href="https://unsplash.com/photos/guvnhd3hbxw" class="dimmed">Unsplash</a>
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped>

  .about-container {
    width: 80%;
    margin: auto;
  }

  .img {
    display: inline-block;
    padding: 10px 0;
  }

  img {
    width: 150px;
    height: 150px;
  }

  .text {
    display: inline-block;
    font-size: 20px;
    padding: 10px 0;
  }

</style>
